import { ConfigService } from '@nextgen-web-framework/core';
import { BottomNavigationItemsProps } from '../components/bottomNavigationItems/types/propsTypes';
import { BottomNavigationItemType } from '../components/bottomNavigationItems/BottomNavigationItems';
import { CMSTransformerDataType } from '../cms/types/common';

export const transformMobileBottomNavigation = (
  data: CMSTransformerDataType,
  isAnonymous?: boolean,
  fallback?: BottomNavigationItemsProps[],
  isSopMegaMenuEnabled?: boolean,
): BottomNavigationItemsProps[] => {
  const configs = ConfigService.getConfigs();
  const cmsFetchFeatureFlag = configs.NEXT_HEADER_MOBILE_CMS_FETCH;
  const ASSETS_BASE_PATH = configs.NEXT_ASSETS_BASE_PATH;

  if (!data || (Array.isArray(data) && data.length === 0) || !cmsFetchFeatureFlag) {
    return fallback || [];
  }

  const iconMap = [
    { url: '/', activeImageUrl: 'AmwayActive.svg', inactiveImageUrl: 'AmwayWhite.svg', enabled: true },
    { url: '/shopping', activeImageUrl: 'store-Solid.svg', inactiveImageUrl: 'store-Regular.svg', enabled: true },
    { url: '/offers', activeImageUrl: 'tags-Solid.svg', inactiveImageUrl: 'tags-Regular.svg', enabled: true },
    {
      url: '/sop',
      activeImageUrl: 'arrows-rotate-Solid.svg',
      inactiveImageUrl: 'arrows-rotate-Regular.svg',
      enabled: isSopMegaMenuEnabled ?? false,
    },
    {
      url: '/account',
      activeImageUrl: 'circle-user-Solid.svg',
      inactiveImageUrl: 'circle-user-Regular.svg',
      enabled: true,
    },
  ];

  const items = Array.isArray(data) ? data[0] : data;
  const bottomNavigationItems: BottomNavigationItemsProps[] = createNavigationItems(
    items?.menu_items,
    iconMap,
    isAnonymous,
    ASSETS_BASE_PATH as string,
  ).filter(Boolean) as BottomNavigationItemsProps[];

  return bottomNavigationItems.length > 0 ? bottomNavigationItems : fallback || [];
};

const createNavigationItems = (
  menuItems: CMSTransformerDataType,
  iconMap: CMSTransformerDataType,
  isAnonymous?: boolean,
  assetPath?: string,
) =>
  menuItems.map((item: CMSTransformerDataType) => {
    const icon = iconMap.find((icon: CMSTransformerDataType) => icon.url === item.menu_url);
    if (!icon?.enabled) {
      return null;
    }
    return {
      url: item.menu_url,
      label: isAnonymous ? item.title_guest : item.title_logged,
      type: BottomNavigationItemType.Image,
      image: {
        activeImageUrl: `${assetPath}/icons/${icon.activeImageUrl}`,
        inactiveImageUrl: `${assetPath}/icons/${icon.inactiveImageUrl}`,
      },
    };
  });
